/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Text, theme } from "@nordcloud/gnui";
import { EditButton } from "~/components/Buttons";
import { ACTIONS, Can } from "~/services/auth";

type Props = {
  content: string;
  onChange: () => void;
};

export function DisplayText({ content, onChange }: Props) {
  return (
    <>
      <Text as="div" m="0" mr={theme.spacing.spacing02}>
        {content}
      </Text>
      <Can action={ACTIONS.updateWorkflow}>
        <EditButton onClick={onChange} />
      </Can>
    </>
  );
}
